import { Buyer, HomeSummary, Phase, User, UserJob } from '@/types';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { MutationType, ActionType, BuyerType } from '@/constants';

Vue.config.devtools = true
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {} as Buyer,
    badges: {},
    selectedJob: '',
    jobOwnershipStatus: '',
    signedIn: false,
    notFound: false,
    isLoggedInAsAdmin: false,
    impersonatedBuyer: '',
    jobDetails: {} as HomeSummary,
    mileStones: {} as Phase
  },
  plugins: [createPersistedState()],
  getters: {
    allJobs: state => state.user?.allJobs?.concat(state.user.coBuyerJobs) || [] as UserJob[],
    signedIn: state => state.signedIn,
    hasUserData: state => !(Object.keys(state.user).length === 0 && state.user.constructor === Object),
    user: state => state.user,
    jobs: state => state.user.jobs,
    haveMultipleJobs: state => state.user.jobs ? state.user.jobs.length > 1 : false,
    selectedJob: state => state.selectedJob,
    badges: state => state.badges,
    jobOwnershipStatus: state => state.jobOwnershipStatus,
    notFound: state => state.notFound,
    isLoggedInAsAdmin: state => state.isLoggedInAsAdmin,
    impersonatedBuyer: state => state.impersonatedBuyer,
    selectedJobBuyers: state => state.user?.jobs?.find(job => job.jobNumber === state.selectedJob)?.buyers || [] as User[],
    selectedJobDetails: state => state.user?.jobs?.find(job => job.jobNumber === state.selectedJob),
    isCoBuyer: (state, getters) => !!getters.selectedJob && !!(getters.selectedJobBuyers.find((user: User) => user.email === state.user.email).buyerType === BuyerType.COBUYER),
    jobDetails: state => state.jobDetails,
    mileStones: state => state.mileStones
  },
  mutations: {
    [MutationType.UPDATE_NOT_FOUND_STATUS] (state, payload: boolean) {
      state.notFound = payload;
    },
    [MutationType.UPDATE_USER_DATA] (state, payload: Buyer) {
      state.user = payload;
    },
    [MutationType.UPDATE_SIGNIN_STATUS] (state, payload: boolean) {
      state.signedIn = payload;
    },
    [MutationType.UPDATE_SELECTED_JOB] (state, job: string) {
      state.selectedJob = job;
    },
    [MutationType.UPDATE_JOB_BADGES] (state, payload) {
      state.badges = payload;
    },
    [MutationType.CLEAR_BADGE] (state, payload) {
      (state.badges as any)[payload] = 0;
    },
    [MutationType.SET_JOB_OWNERSHIP_STATUS] (state, status: string) {
      state.jobOwnershipStatus = status;
    },
    [MutationType.SET_LOGGED_IN_AS_ADMIN] (state, value: boolean) {
      state.isLoggedInAsAdmin = value;
    },
    [MutationType.SET_IMPERSONATED_BUYER] (state, value: string) {
      state.impersonatedBuyer = value;
    },
    [MutationType.SET_JOB_DETAILS] (state, value: HomeSummary) {
      state.jobDetails = value;
    },
    [MutationType.SET_MILESTONE_DATA] (state, value: Phase) {
      state.mileStones = value;
    }
  },
  actions: {
    [ActionType.UPDATE_NOT_FOUND_STATUS] ({ commit }, payload: boolean) {
      commit(MutationType.UPDATE_NOT_FOUND_STATUS, payload);
    },
    [ActionType.UPDATE_USER_DATA] ({ commit }, payload: Buyer) {
      commit(MutationType.UPDATE_USER_DATA, payload);
    },
    [ActionType.UPDATE_SIGNIN_STATUS] ({ commit }, payload: boolean) {
      commit(MutationType.UPDATE_SIGNIN_STATUS, payload);
    },
    [ActionType.UPDATE_SELECTED_JOB] ({ commit }, job: string) {
      commit(MutationType.UPDATE_SELECTED_JOB, job);
    },
    [ActionType.UPDATE_JOB_BADGES] ({ commit }, payload) {
      commit(MutationType.UPDATE_JOB_BADGES, payload);
    },
    [ActionType.CLEAR_BADGE] ({ commit }, payload) {
      commit(MutationType.CLEAR_BADGE, payload);
    },
    [ActionType.SET_JOB_OWNERSHIP_STATUS] ({ commit }, status: string) {
      commit(MutationType.SET_JOB_OWNERSHIP_STATUS, status);
    },
    [ActionType.SET_LOGGED_IN_AS_ADMIN] ({ commit }, value: boolean) {
      commit(MutationType.SET_LOGGED_IN_AS_ADMIN, value);
    },
    [ActionType.SET_IMPERSONATED_BUYER] ({ commit }, value: string) {
      commit(MutationType.SET_IMPERSONATED_BUYER, value);
    },
    [ActionType.SET_JOB_DETAILS] ({ commit }, value: HomeSummary) {
      commit(MutationType.SET_JOB_DETAILS, value);
    },
    [ActionType.SET_MILESTONE_DATA] ({ commit }, value: Phase) {
      commit(MutationType.SET_MILESTONE_DATA, value);
    }
  },
  modules: {
  }
})
